/* eslint-disable  */
// import { getCoreBlocks } from './core.js';

const gap = '<sep gap="36"/>';
const blockSeparator = '<sep gap="36"/>'; // At default scale, about 28px


const cdg2_event_blocks = function () {
    return `
  <category
    name="Event"
    id="cdg3_event"
    colour="#FFBF00"
    secondaryColour="#E6AC00">

    <block type="cdg2_event_whenaltitude_lt" >
      <value name="VALUE">
              <shadow type="math_positive_number">
                  <field name="NUM">100</field>
              </shadow>
      </value>
    </block>
    <block type="cdg2_event_whenaltitude_eq" >
      <value name="VALUE">
              <shadow type="math_positive_number">
                  <field name="NUM">100</field>
              </shadow>
      </value>
    </block>


    <block type="cdg2_event_whenspeed_gt" >
    <value name="VALUE">
            <shadow type="math_positive_number">
                <field name="NUM">100</field>
            </shadow>
    </value>
    </block>
    <block type="cdg2_event_whenspeed_lt" >
      <value name="VALUE">
              <shadow type="math_positive_number">
                  <field name="NUM">100</field>
              </shadow>
      </value>
    </block>
    <block type="cdg2_event_whenspeed_eq" >
      <value name="VALUE">
              <shadow type="math_positive_number">
                  <field name="NUM">100</field>
              </shadow>
      </value>
    </block>

    <block type="cdg2_event_whenenergy_gt" >
    <value name="VALUE">
            <shadow type="math_positive_number">
                <field name="NUM">100</field>
            </shadow>
    </value>
    </block>
    <block type="cdg2_event_whenenergy_lt" >
      <value name="VALUE">
              <shadow type="math_positive_number">
                  <field name="NUM">100</field>
              </shadow>
      </value>
    </block>
    <block type="cdg2_event_whenenergy_eq" >
      <value name="VALUE">
              <shadow type="math_positive_number">
                  <field name="NUM">100</field>
              </shadow>
      </value>
    </block>

  </category>
  `
}
const cdg2_sensing_blocks = function () {
    return `
  <category
    name="Sensing"
    id="cdg3_sensing"
    colour="#3ECBF0"
    secondaryColour="#2cb5da">
      <block type="cdg3_sensing_captured_toxibots">
      </block>
      <block type="cdg3_sensing_toxibots_nearby">
      </block>
      <block type="cdg3_sensing_stunned_toxibots">
      </block>
      <block type="cdg3_sensing_attacking_toxibots">
      </block>
  </category>
  `
}
const cdg2_action_blocks = function () {
    return `
  <category
    name="Driving"
    id="cdg2_drive"
    colour="#F65DCE"
    secondaryColour="#E20F9C">
      
      <block type="cdg2_drive_set_engine_to">
        <value name="TARGET">
            <shadow type="cdg2_direction_dropdown">
                <field name="TARGET">Accelerate</field>
            </shadow>
        </value>
      </block>
      <block type="cdg2_drive_steer" >
          <value name="HEADING">
            <shadow type="spike_heading_input">
                <field name="NUM">0</field>
            </shadow>
        </value>
      </block>
      <block type="cdg2_drive_handbrake">
        <field name="TARGET">On</field>
      </block>
  </category>
  <category
    name="Social"
    id="cdg2_sensing"
    colour="#C926FF"
    secondaryColour="#B30CEB">

    <block type="cdg2_social_say" />
    <block type="cdg2_social_horn" />
    </category>
  <category
    name="Booster"
    id="cdg3_booster"
    colour="#4C97FF"
    secondaryColour="#4280D7">
    <block type="cdg2_booster_set_booster_power" >
      <value name="TARGET">
            <shadow type="cdg2_booster_off_dropdown">
                <field name="TARGET">Forward Booster</field>
            </shadow>
        </value>
          <value name="RATE">
            <shadow type="math_positive_number">
                <field name="NUM">100</field>
            </shadow>
        </value>
      </block>
      <block type="cdg2_booster_turn_on_booster" >
      <value name="TARGET">
            <shadow type="cdg2_booster_dropdown">
                <field name="TARGET">Forward Booster</field>
            </shadow>
        </value>
      </block>
      <block type="cdg2_booster_turn_off_booster">
      <value name="TARGET">
            <shadow type="cdg2_booster_off_dropdown">
                <field name="TARGET">Forward Booster</field>
            </shadow>
        </value>
      </block>
  </category>
<category
    name="Autofly"
    id="cdg2_fly"
    colour="#ff8901"
    secondaryColour="#FF5C01">
      <block type="cdg2_fly_activate" />
      <block type="cdg2_fly_height">
      <value name="DISTANCE">
            <shadow type="math_positive_number">
                <field name="NUM">10</field>
            </shadow>
        </value>
      </block>
      <block type="cdg2_fly_heading">
      <value name="HEADING">
            <shadow type="math_number">
                <field name="NUM">90</field>
            </shadow>
        </value>
      </block>
      <block type="cdg2_fly_speed">
      <value name="SPEED">
            <shadow type="math_number">
                <field name="NUM">100</field>
            </shadow>
        </value>
      </block>
    </category>
  
     <category
    name="Sensing"
    id="cdg2_sensing"
    colour="#3ECBF0"
    secondaryColour="#2cb5da">
    <block type="cdg2_sensing_get_value">
      <value name="TARGET">
            <shadow type="cdg2_sensing_dropdown">
                <field name="TARGET">height</field>
            </shadow>
        </value>
      </block>
    </category>

     
    <category
    name="Events"
    id="cdg2_event"
    colour="#FFBF00"
    secondaryColour="#E6AC00">
      <block type="event_whenkeypressed" />
      <block type="event_whenkeyreleased" />
    </category>

    <category name="%{BKY_CATEGORY_OPERATORS}" id="operators" colour="#40BF4A" secondaryColour="#389438">
<block type="operator_add">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
      <block type="operator_subtract">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
      <block type="operator_multiply">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
      <block type="operator_divide">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
  <block type="operator_gt">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
<block type="operator_lt">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
<block type="operator_equals">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
${blockSeparator}
<block type="operator_and"/>
<block type="operator_or"/>
<block type="operator_not"/>
${blockSeparator}
</category>

    <category
    name="Settings"
    id="cdg2_event"
    colour="#40BF4A"
    secondaryColour="#389438">
    <block type="cmra_common_action_open_programming" />
    <block type="cmra_common_action_reset_vehicle" />
    <block type="cdg2_drive_change_vehicle" />


    </category>

  `
}
const cdg2_control_blocks = function () {
    return `
  <category name="%{BKY_CATEGORY_CONTROL}" id="control" colour="#FFAB19" secondaryColour="#CF8B17">
    <block type="control_if"/>
    <block type="control_if_else"/>
    <block id="wait_until" type="control_wait_until"/>
  </category>
  `
}
const cdg2_operators_blocks = function () {

    return `
<category name="%{BKY_CATEGORY_OPERATORS}" id="operators" colour="#40BF4A" secondaryColour="#389438">
<block type="operator_add">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
      <block type="operator_subtract">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
      <block type="operator_multiply">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
      <block type="operator_divide">
          <value name="NUM1">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
          <value name="NUM2">
              <shadow type="math_number">
                  <field name="NUM"/>
              </shadow>
          </value>
      </block>
  <block type="operator_gt">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
<block type="operator_lt">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
<block type="operator_equals">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
${blockSeparator}
<block type="operator_and"/>
<block type="operator_or"/>
<block type="operator_not"/>
${blockSeparator}
</category>`

}
const makeCDG2ToolboxXML = () => {
    const xmlOpen = '<xml style="display: none">';
    const xmlClose = "</xml>";
    // const coreCategories = getCoreBlocks();
    return [
        xmlOpen,
        // gap,
        // cdg2_event_blocks(),
        gap,
        cdg2_action_blocks(),
        // gap,
        // cdg2_sensing_blocks(),
        // gap,
        cdg2_control_blocks(),
        //gap,
        //cdg2_operators_blocks(),
        // gap,
        xmlClose
    ].join("\n");
}

export { makeCDG2ToolboxXML };